// extracted by mini-css-extract-plugin
export default {"meetingStatus":"Dqsw+","button":"BDMpQ","buttonDisabled":"T3B8r","meetingText":"yrQfD"};